export enum OrderEntryStatus {
    InProgress,
    Completed
}